export default {
    text: {
        title: 'Teksti',
        addText: 'Uusi teksti',
        fontFamily: 'Kirjasintyyppi',
        fontSize: 'Font size',
        textAlignment: 'Tekstin tasaus',
        fontColor: 'Tekstin väri',
        lineSpacing: 'Riviväli',
        arialSerif: 'Arial (hakatyyppinen)',
        verdanaSansSerif: ' Verdana (sans-serif)',
        tahomaSansSerif: 'Tahoma (ilman käsialaa)',
        trebuchetMSSansSerif: 'Trebuchet MS (ei-serifi)',
        timesNewRomanSerif: 'Times New Roman (seriffin)',
        georgiaSerif: 'Georgia (serif)',
        garamondSerif: 'Garamond (seriffi)',
        courierNewMonospace: 'Courier New (monospace)',
        brushScriptMTCursive: 'Kalligrafiafontti Brush Script MT',
        backgroundColor: 'Taustaväri',
    },
};
